/* eslint-disable indent */
/* eslint-disable space-before-function-paren */

import AuthApi from '@/controllers/AuthApis'
import { URL } from '@/store/modules/auth/env'
import * as types from '@/store/mutation-types'
import store from '@/store/store'

export default {
    async fetchUserBusinessList({ commit }) {
        const url = `${URL}/api/v1/users/businesses`
        await AuthApi.getApi(url)
            .then(response => {
                commit(types.SET_BUSINESS_LIST, response.data.payload)
            })
    },

    async getBusinessBranding({ commit }, id) {
        const url = `${URL}/api/v1/businesses/${id}?withBranding=true`
        await AuthApi.getApi(url)
            .then(response => {
                commit(types.SET_USER_SELECTED_ACCOUNT, response.data.payload)
                if (response.data.payload.branding) {
                    commit(types.SET_BUSINESS_BRANDING, response.data.payload.branding)
                }
            })
            .catch(err => {
                console.log(err.response)
            })
    }
}
